/* Selector de piata - modal cu cautare.
 *
 * Delegare de evenimente pe `document`, nu listener per buton: exista DOUA
 * declansatoare (desktop + sertar mobil), randate in ordine variabila (in
 * header.liquid cel mobil e la linia 203, cel desktop la 521), si un singur
 * modal. Delegarea functioneaza indiferent de ordinea de randare si nu
 * necesita re-atasare cand sertarul se deschide/inchide.
 *
 * Steagurile sunt <img> cu SVG local (assets/flag-<cod>.svg), randate direct
 * de Liquid - nu se mai calculeaza nimic in JS. Varianta veche folosea emoji
 * de steag, care pe Windows se afiseaza ca doua litere.
 */
(function () {
  if (window.__selectorPiataInit) return;
  window.__selectorPiataInit = true;

  function init() {
    var modal = document.getElementById('SelectorPiataModal');
    if (!modal) return;

    /* Modalul se randeaza din `sections/header.liquid`, iar header-ul e
       `position: sticky`, deci isi creeaza PROPRIUL context de stivuire. Cat
       timp modalul ramane inauntru, `z-index: 100` concureaza doar cu fratii
       lui din header - nu cu bara de anunt, care ajungea peste campul de
       cautare. Mutat in `<body>`, modalul intra in contextul radacina si
       acopera tot, fara razboaie de z-index. */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    var form = document.getElementById('SelectorPiataForm');
    var campTara = form.querySelector('[data-camp="country_code"]');
    var campLimba = form.querySelector('[data-camp="locale_code"]');
    var cautare = modal.querySelector('[data-selector-piata-cautare]');
    var lista = modal.querySelector('[data-selector-piata-lista]');
    var panou = modal.querySelector('.selector-piata-modal__panou');

    /* Focus automat pe cautare DOAR pe desktop.

       Pe telefon, focusul deschide tastatura virtuala in clipa in care se
       deschide modalul. Doua efecte, amandoua raportate ca defecte separate pe
       23.09.2026, dar avand aceeasi cauza: se strica UX-ul (utilizatorul voia
       sa aleaga din lista, nu sa scrie), si mai ales **tastatura acopera bara
       "Rest of the World" de la baza** - de aceea pe mobil „nu se vedea nicio
       limba" iar pe desktop totul parea in regula. Tastatura NU micsoreaza
       `dvh`, deci nicio ajustare de inaltime nu putea repara asta.

       `pointer: fine` deosebeste mausul de deget mai fiabil decat latimea
       ecranului: o fereastra ingusta pe desktop tot merita focus. */
    var potFocusa = window.matchMedia('(min-width: 750px) and (pointer: fine)');

    function deschide() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      // ascunde chatul Shopify Inbox cat timp modalul e deschis: e `fixed` in
      // coltul de jos si acoperea randul "Rest of the World"
      document.documentElement.classList.add('selector-piata-deschis');
      if (cautare) {
        cautare.value = '';
        filtreaza('');
        if (potFocusa.matches) {
          window.setTimeout(function () { cautare.focus(); }, 0);
        }
      }
    }

    function inchide() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('selector-piata-deschis');
      if (panou) panou.style.height = '';
    }

    /* Tastatura virtuala acopera baza ecranului fara sa micsoreze `dvh`, deci
       bara "Rest of the World" ar dispărea sub ea de indata ce cineva atinge
       campul de cautare pe telefon. `visualViewport` e singurul care raporteaza
       inaltimea CHIAR vizibila; potrivim panoul pe ea, si bara ramane mereu
       deasupra tastaturii. Doar pe ecranul mic, unde panoul e pe tot ecranul -
       pe desktop panoul e centrat si nu are nevoie. */
    if (window.visualViewport && panou) {
      var micut = window.matchMedia('(max-width: 749px)');
      var potriveste = function () {
        if (modal.hidden) return;
        panou.style.height = micut.matches
          ? window.visualViewport.height + 'px'
          : '';
      };
      window.visualViewport.addEventListener('resize', potriveste);
      window.visualViewport.addEventListener('scroll', potriveste);
    }

    function filtreaza(text) {
      if (!lista) return;
      var q = (text || '').trim().toLowerCase();
      var vizibile = 0;
      lista.querySelectorAll('.selector-piata-modal__rand').forEach(function (li) {
        var nume = li.getAttribute('data-nume') || '';
        var ascuns = q.length > 0 && nume.indexOf(q) === -1;
        li.hidden = ascuns;
        if (!ascuns) vizibile++;
      });
      // zero potriviri: se arata mesajul, iar pastilele de limba de jos raman
      // vizibile - ele nu se filtreaza niciodata
      lista.classList.toggle('selector-piata-modal__lista--gol', vizibile === 0);
    }

    function submite(taraNoua, localeNou) {
      if (taraNoua) campTara.value = taraNoua;
      if (localeNou) campLimba.value = localeNou;
      form.submit();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-selector-piata-declansator]')) {
        e.preventDefault();
        deschide();
        return;
      }
      if (e.target.closest('[data-selector-piata-inchide]')) {
        e.preventDefault();
        inchide();
        return;
      }
      var randTara = e.target.closest('[data-tara]');
      if (randTara) {
        e.preventDefault();
        submite(randTara.getAttribute('data-tara'), randTara.getAttribute('data-locale'));
        return;
      }
      var randLimba = e.target.closest('[data-limba]');
      if (randLimba) {
        e.preventDefault();
        submite(null, randLimba.getAttribute('data-limba'));
        return;
      }
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && !modal.hidden) inchide();
    });

    if (cautare) {
      cautare.addEventListener('input', function () { filtreaza(cautare.value); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
